import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV = [
  { label: 'Home',         path: '/' },
  { label: 'Services',     path: '/services' },
  { label: 'Projects',     path: '/projects' },
  { label: 'Apps',         path: '/apps' },
  { label: 'Courses',      path: '/courses' },
  { label: 'Team',         path: '/team' },
  { label: 'Reviews',      path: '/testimonials' },
  { label: 'Contact',      path: '/contact' },
  // { label: 'Certificate',      path: '/certificate' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const { pathname }            = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const navBase = `fixed top-0 left-0 right-0 z-[1000] h-[68px] px-8 flex items-center justify-between transition-all duration-300 border-b`;
  const navScroll = scrolled
    ? 'bg-[#050810]/95 border-[rgba(0,245,255,.14)] shadow-[0_2px_30px_rgba(0,0,0,.4)] backdrop-blur-xl'
    : 'bg-[#050810]/65 border-[rgba(0,245,255,.07)] backdrop-blur-xl';

  return (
    <>
      <nav className={`${navBase} ${navScroll}`} role="navigation" aria-label="Main navigation">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 no-underline" aria-label="VTCodex Home">
          <img
            src="/logo.jpeg"
            alt="VTCodex Logo"
            className="w-10 h-10 rounded-xl object-cover"
            style={{ filter: 'drop-shadow(0 0 8px rgba(0,245,255,.5))' }}
          />
          <span className="font-bold text-2xl tracking-wide">
            <span className="text-white">VT</span>
            <span className="grad-text">Codex</span>
          </span>
        </Link>

        {/* Desktop links */}
        <ul className="hidden xl:flex gap-5 list-none">
          {NAV.map(({ label, path }) => (
            <li key={path}>
              <Link
                to={path}
                className={`text-[0.98rem] font-semibold no-underline transition-all duration-300 relative pb-1 whitespace-nowrap
                  ${pathname === path ? 'text-[#00f5ff] [text-shadow:0_0_10px_rgba(0,245,255,.45)]' : 'text-slate-400 hover:text-[#00f5ff]'}
                `}
                aria-current={pathname === path ? 'page' : undefined}
              >
                {label}
                <span className={`absolute bottom-0 left-0 right-0 h-[2px] rounded transition-transform duration-300 origin-left
                  ${pathname === path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}
                `}
                  style={{ background: 'linear-gradient(#00f5ff,#8b5cf6)' }}
                />
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA — Python Bootcamp button */}
        <Link
          to="/contact"
          className="hidden xl:inline-block text-sm font-bold px-5 py-2.5 rounded-xl transition-all duration-300 no-underline hover:-translate-y-0.5"
          style={{
            background: 'linear-gradient(135deg,#f472b6,#8b5cf6)',
            color: '#fff',
            boxShadow: '0 0 18px rgba(244,114,182,0.35)',
          }}
          aria-label="Python Bootcamp"
        >
          {/* 🐍 Python Bootcamp */}
          Chat with us
        </Link>

        {/* Hamburger */}
        <button
          className="xl:hidden flex flex-col gap-[5px] bg-transparent border-none cursor-none p-1"
          onClick={() => setOpen(!open)}
          aria-label="Toggle mobile menu"
          aria-expanded={open}
        >
          <span className="block w-6 h-0.5 bg-[#00f5ff] transition-all duration-300"
            style={{ transform: open ? 'rotate(45deg) translate(5px,5px)' : '' }} />
          <span className="block w-6 h-0.5 bg-[#00f5ff] transition-all duration-300"
            style={{ opacity: open ? 0 : 1 }} />
          <span className="block w-6 h-0.5 bg-[#00f5ff] transition-all duration-300"
            style={{ transform: open ? 'rotate(-45deg) translate(5px,-5px)' : '' }} />
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 top-[68px] z-[999] flex-col items-center justify-center gap-8 bg-[#050810]/97 backdrop-blur-xl transition-all duration-300 ${open ? 'flex' : 'hidden'}`}
        role="dialog"
        aria-label="Mobile navigation"
      >
        {NAV.map(({ label, path }) => (
          <Link
            key={path}
            to={path}
            className="font-cursive text-2xl font-semibold text-slate-400 no-underline transition-all duration-300 hover:text-[#00f5ff] hover:[text-shadow:0_0_15px_rgba(0,245,255,.5)]"
          >
            {label}
          </Link>
        ))}
        {/* Mobile bootcamp button */}
        <Link
          to="/contact?tab=bootcamp"
          className="font-bold text-xl no-underline px-8 py-3 rounded-xl mt-2"
          style={{ background: 'linear-gradient(135deg,#f472b6,#8b5cf6)', color: '#fff' }}
        >
          {/* 🐍 Python Bootcamp */}
          Chat with us
        </Link>
      </div>
    </>
  );
}